










































import { Component, Vue, Watch } from 'vue-property-decorator';
import MenuComponent from './components/menu.vue';

@Component({
  components: {
    MenuComponent
  }
})
export default class App extends Vue {
  account = this.$store.state.account;
  state = this.$store.state.alert;
  application = this.$store.state.application;
  snackbar = false;
  snackbarText = '';
  snackbarSeverity = 'success';
  langs = ['cs', 'en'];
  environment = process.env.VUE_APP_ENV && process.env.VUE_APP_ENV !== '' ? process.env.VUE_APP_ENV : null;

  mounted() {
    const langCode = this.$cookies.get('jcu_language');
    if (langCode) {
      this.$i18n.locale = langCode;
    }
  }

  @Watch('state', { immediate: true, deep: true })
  onStateChange(newVal: any) {
    if (newVal.message) {
      this.snackbar = true;
      this.snackbarText = newVal.message;
      this.snackbarSeverity = newVal.type;
    }
  }

  @Watch('currentLocale')
  onLanguageChange(newVal: any) {
    if (newVal) {
      this.$vuetify.lang.current = newVal;
      this.$cookies.set('jcu_language', newVal);
    }
  }

  get currentLocale() {
    return this.$i18n.locale;
  }

  toggleMenu() {
    (this as any).$store.dispatch('application/toggleMenu');
  }
}
